import React from 'react'
import { Modal } from '../../_EOS/Modal'
import { ConfirmAction } from '../../ConfirmAction'

interface DispatchConfirmModalProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  workOrderId?: number
  isLoading?: boolean
}

export const DispatchConfirmModal: React.FC<DispatchConfirmModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  workOrderId,
  isLoading = false
}) => {
  return (
    <Modal onClose={onClose} open={isOpen} maxWidth='xs'>
      <ConfirmAction
        handleCloseModal={onClose}
        handleSubmitAction={onConfirm}
        confirmTitle={`¿Está seguro que desea Despachar OT N° ${workOrderId}?`}
        confirmText='Confirmar'
        negateText='Cancelar'
        isLoading={isLoading}
        confirmHeaderText='Despachar OT'
      />
    </Modal>
  )
} 